import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {

	/**
	 * 充电桩列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	chargingList( params={} ) {
		return request({
	    url: baseUrl + '/charging/index',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 充电桩修改
	**/
	chargingEdit(id,data){
		return request({
			url: baseUrl + '/charging/editCharging/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 充电桩删除
	**/
	chargingDel(id){
		return request({
			url: baseUrl + '/charging/delCharging/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 充电桩添加
	**/
	chargingAdd(data){
		return request({
			url: baseUrl + '/charging/addCharging',
			method:'POST',
			data
		})
	}
}